export default class FileUtils {
    static download(data: any, filename: string, contentType: string = 'application/json') {
        const windowUrl = window.URL || window.webkitURL;
        let blob;
        if (data instanceof Blob) {
            blob = data;
        } else {
            blob = new Blob([typeof data !== 'string' ? JSON.stringify(data) : data], { type: contentType });
        }

        const dataUrl = windowUrl.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = dataUrl;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}
